import { ReactNode, MouseEvent } from "react"

type EditorToolbarButtonProps = {
  icon: ReactNode
  label: string
  onClick: () => void
  isActive?: boolean
  disabled?: boolean
}

const EditorToolbarButton = ({
  icon,
  label,
  onClick,
  isActive = false,
  disabled = false,
}: EditorToolbarButtonProps) => {
  const handleMouseDown = (event: MouseEvent<HTMLButtonElement>) => {
    // Keep editor selection (needed for table row/column commands).
    event.preventDefault()
  }

  return (
    <button
      type='button'
      className={`tiptap-editor__toolbar-btn${isActive ? " is-active" : ""}`}
      onMouseDown={handleMouseDown}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      title={label}
    >
      {icon}
    </button>
  )
}

export default EditorToolbarButton
